module.exports = __webpack_public_path__ + "img/trophy-solid.77c6dc34.svg";